import React, { Fragment } from "react";
import { Inline, PolicyBlock } from "./policyContent";

const EMAIL_PATTERN = /([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/;

/** Renders plain text, turning any email address into a mailto: link. */
const LinkifiedText = ({ text }: { text: string }) => {
	const parts = text.split(EMAIL_PATTERN);
	return (
		<>
			{parts.map((part, index) =>
				// split() with a capture group puts the matched emails at odd indexes
				index % 2 === 1 ? (
					<a key={index} href={`mailto:${part}`}>
						{part}
					</a>
				) : (
					<Fragment key={index}>{part}</Fragment>
				)
			)}
		</>
	);
};

export const InlineContent = ({ content }: { content: Inline[] }) => (
	<>
		{content.map((run, index) =>
			typeof run === "string" ? (
				<LinkifiedText key={index} text={run} />
			) : (
				<strong key={index}>
					<LinkifiedText text={run.bold} />
				</strong>
			)
		)}
	</>
);

export const PolicyBlockView = ({ block }: { block: PolicyBlock }) => {
	switch (block.kind) {
		case "paragraph":
			return (
				<p className="pp-paragraph">
					<InlineContent content={block.content} />
				</p>
			);
		case "list":
			return (
				<ul className="pp-list">
					{block.items.map((item, index) => (
						<li key={index}>
							<InlineContent content={item} />
						</li>
					))}
				</ul>
			);
		case "address":
			return (
				<address className="pp-address">
					{block.lines.map((line, index) => (
						<Fragment key={index}>
							{index > 0 && <br />}
							<InlineContent content={line} />
						</Fragment>
					))}
				</address>
			);
		default:
			return null;
	}
};
